import type { ReactNode } from "react";

/** Wraps legacy value-card panels so they render cleanly inside V10 chrome. */
export function V10EvidenceLegacyScope({ children }: { readonly children: ReactNode }) {
  return <div className="v10-cl-evidence-legacy">{children}</div>;
}
